<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-modal
        title="Choose period"
        class="modal-primary"
        v-model="modalDate"
        @ok="fetchData(), modalDate = false"
      >
        <b-form>
          <b-form-group label="From" label-for="date" :label-cols="3">
            <datepicker use-utc
              format="MM/dd/yyyy"
              :bootstrap-styling="true"
              v-model="dateFrom"
              name="dateFrom"
            ></datepicker>
          </b-form-group>
          <b-form-group label="To" label-for="dateTo" :label-cols="3">
            <datepicker use-utc
              format="MM/dd/yyyy"
              :bootstrap-styling="true"
              v-model="dateTo"
              name="dateTo"
            ></datepicker>
          </b-form-group>
        </b-form>
      </b-modal>

      <b-card class="backClass" header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            Beyond Economic Repair
            <small style="font-weight:600; color:#20a8d8">
              {{ from ? $formatUSDate(from) : $formatUSDate(dateFrom) }}
              <b>|</b>
              {{ to ? $formatUSDate(to) : $formatUSDate(dateTo) }}
            </small>
          </h5>
          <div class="card-header-actions">
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadPDF()"
            >
              <i class="fa fa-file-pdf-o" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
            </b-button>
            <b-button
              @click="modalDateEvent"
              class
              style="height: 26px; width: 26px"
              variant="transparent p-0"
            >
              <i class="icon-calendar" style="color: #20a8d8;"></i>
            </b-button>
            <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
          </div>
        </div>
        <div class="chart-wrapper" style="margin-top: 30px">
          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <div slot="footer" v-if="locParam==1">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            variant="outline-primary"
            left
            @click="showAll = false, fetchData()"
          >Top 10</b-button>
          <b-button
            :disabled="showAll"
            class="btn-outline float-right"
            variant="outline-primary"
            right
            @click="showAll = true, fetchData()"
          >All Data</b-button>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../router";
import Datepicker from "vuejs-datepicker";

export default {
  name: "ActiveBacklog-Column",
  components: {
    router,
    highcharts: Chart,
    Datepicker
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      dateFrom: "",
      dateTo: "",
      city: "",
      locationName: "",
      productGroup: "",
      productModel: "",
      locationsIds: "",
      chartOptions: {
        chart: {
          type: "column",
          backgroundColor: "transparent",
          events: {
            drilldown: ({ point }) => {
              this.productGroup = point.name;
            },
            drillup: ({ e }) => {
              this.productGroup = "";
            }
          }
        },
        title: {
          text: "",
          style: {
            color: "white",
            display: ""
          }
        },
        subtitle: {
          text: "Click to see product models",
          style: {
            color: "white",
            display: ""
          }
        },
        exporting: {
          enabled: true
        },

        xAxis: {
          type: "category",
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          title: {
            text: "Percentage Of Total"
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false,
              format: "{point.name}: {point.y:.1f}%",
              color: "white",
              style: {
                textOutline: false
              }
            },
            point: {
              events: {
                click: ({ point }) => {
                  if (typeof this.dateFrom === "object") {
                    this.dateFrom = this.dateFrom.toISOString().split("T")[0];
                  }
                  if (typeof this.dateTo === "object") {
                    this.dateTo = this.dateTo.toISOString().split("T")[0];
                  }
                  if (point.name) {
                    this.productModel = point.name;
                    if (this.locParam == 1) {
                      router.push(
                        "/base/Tables/?location=" +
                          this.locationName +
                          "&productModel=" +
                          this.productGroup +
                          "&type=ber&date_from=" +
                          this.dateFrom +
                          "&date_to=" +
                          this.dateTo +
                          "&clients=" +
                          this.locationsIds
                      );
                    } else {
                      router.push(
                        "/base/Tables/?location=" +
                          this.city +
                          "&productModel=" +
                          this.productModel +
                          "&productGroup=" +
                          this.productGroup +
                          "&type=ber&date_from=" +
                          this.dateFrom +
                          "&date_to=" +
                          this.dateTo +
                          "&clients=" +
                          this.locationsIds
                      );
                    }
                  }
                }
              }
            }
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            textDecoration: "none",
            color: "white"
          },
          activeDataLabelStyle: {
            color: "white"
          }
        },
        series: [
          {
            name: "Product Groups",
            colorByPoint: true,
            data: null
          }
        ]
      }
    };
  },

  methods: {
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo,
        chartType: "BER",
        client: this.idCity,
        productCategory: "XM3"
      };
      this.$http
        .get("api/alpha/charts/chart_city.php", { params })
        .then(
          res => {
            this.chartOptions.title.text = "Total units: " + res.data.totals;

            if (!this.showAll) {
              let tmp = res.data.upData;
              tmp.sort((a, b) =>
                parseFloat(a.ProductGroupTotal) > parseFloat(b.ProductGroupTotal)
                  ? -1
                  : 1
              );

              let smp = res.data.dnData;

              smp.forEach((value, index) => {
                value.data.sort((a, b) =>
                  parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
                );
              });

              let newArr = tmp.slice(0, 10);
             
              this.chartOptions.series[0].data = newArr;
              this.chartOptions.drilldown.series = smp;
              
            } else {
              let smp = res.data.dnData;

              smp.forEach((value, index) => {
                value.data.sort((a, b) =>
                  parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
                );
              });
              let tmp = res.data.upData;
              tmp.sort((a, b) =>
                parseFloat(a.ProductGroupTotal) > parseFloat(b.ProductGroupTotal)
                  ? -1
                  : 1
              );
             
                this.chartOptions.series[0].data = tmp;
                this.chartOptions.drilldown.series = smp;
             
            }

            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    modalDateEvent() {
      if (this.fullScreen) {
        this.toggleFullScreen();
        this.modalDate = true;
      } else {
        this.modalDate = true;
      }
    },
    downloadPDF() {
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Beyond Economic Repair | " +
          (this.from ? this.from : this.dateFrom) +
          " - " +
          (this.to ? this.to : this.dateTo) +
          " " +
          this.locationName;
        this.$refs.backRef.chart.options.title.style.color = "black";
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Beyond Economic Repair | " + this.from
            ? this.from
            : this.dateFrom + " - " + this.to
            ? this.to
            : this.dateTo + " " + this.nameCity;
        this.$refs.backRef.chart.options.title.style.color = "black";
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename:
          "BER-" +
          (this.from ? this.from : this.dateFrom) +
          "-" +
          (this.to ? this.to : this.dateTo)
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },
  computed: {
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
    }
  },
  mounted() {
    if (!localStorage.getItem("alpha_user")) {
      router.push("/pages/login/");
    }

    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
      this.city = this.nameCity + "%287%29";
    }

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
